/* eslint-disable @typescript-eslint/no-unused-vars */
export const API_V1 = "/api/v1/";

const DOMAIN_URI_DEV = "https://backend.dev.sslmemo.com";
const DOMAIN_URI_STAGE = "";
const DOMAIN_URI_PROD = "";
export const DOMAIN_URI = DOMAIN_URI_DEV;
